module.exports = __webpack_public_path__ + "img/40.20a0d697.png";